import { OrderConfirmation } from '@fhs-legacy/frontend/src/pages/order-confirmation';
export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default function OrderConfirmationPage() {
  return <OrderConfirmation />;
}
